import { render } from "./LangButton.vue?vue&type=template&id=3100e487&scoped=true"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"

import "./LangButton.vue?vue&type=style&index=0&id=3100e487&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/tutuyoutoo-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3100e487"]])

export default __exports__